module.exports = __webpack_public_path__ + "SourceSans3-BlackIt.otf.05ab1.woff";